import { render } from "./AudioEdit.vue?vue&type=template&id=08af032a&scoped=true"
import script from "./AudioEdit.vue?vue&type=script&lang=js"
export * from "./AudioEdit.vue?vue&type=script&lang=js"

import "./AudioEdit.vue?vue&type=style&index=0&id=08af032a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08af032a"],['__file',"src/components/mediaproperty/AudioEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "08af032a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('08af032a', __exports__)) {
    api.reload('08af032a', __exports__)
  }
  
  module.hot.accept("./AudioEdit.vue?vue&type=template&id=08af032a&scoped=true", () => {
    api.rerender('08af032a', render)
  })

}


export default __exports__